
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { AddNewCouponForm } from "../form/AddNewCouponForm";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column
//   align-items: flex-end;
// `;


type AddNewCouponDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const AddNewCouponDrawer: React.FC<AddNewCouponDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer()

  return (

    <Drawer
      title={t("coupons.actions.add_new.drawer.title")}
      placement="right"
      width={800}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      {
        isDrawerOpen &&
        <AddNewCouponForm
          referenceDrawer={referenceDrawer}
          onCloseDrawer={setDrawerOpen}
        />
      }
    </Drawer>
  );
};
